/* eslint-disable no-else-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { MdHotel, MdOutlineDoNotDisturb } from 'react-icons/md';
import { TiTick } from 'react-icons/ti';
import { ImCross } from 'react-icons/im';
import { Card, Col, Row } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppLink from '../../../shared/components/app-link/AppLink';
import { getRoomCancellationRulesApi } from '../../../api/hotelApi';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import TermsAndConditionsForHotelRoom from './TermsAndCondition';

function RoomCardUI({
  roomDetails,
  thumbnail,
  onRoomChoose,
  currencyOption,
  conversionRate,
  searchRequest,
  totalNights,
}) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [showTerms, setShowTerms] = useState(false);
  const [tncPolicy, setTncPolicy] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);

  const formatCurrency = (amount) => {
    const convertedAmount = amount * conversionRate;
    return `${currencyOption} ${convertedAmount.toFixed(2)}`;
  };

  const handleTerms = async () => {
    const tAndC = roomDetails?.ratePlan?.cancellationPolicy;
    if (
      !isEmpty(tAndC.canxpolicy_modified) ||
      !isEmpty(tAndC.hotelcanxpolicy)
    ) {
      setTncPolicy(tAndC);
      setShowTerms((prev) => !prev);
    } else {
      setIsLoading(true);
      const request = {
        inputData: {
          searchingData: {
            ...searchRequest,
          },
          roomTypeCode: roomDetails.roomType.roomTypeCode,
          hotelCode: roomDetails.hotelCode,
          ratePlanCode: roomDetails.ratePlan.ratePlanCode,
          fareSource: roomDetails.fareSource,
          roomNumber: roomDetails.roomNumber,
        },
        action: 'api_xxln_policy',
        nextratotal: roomDetails.ratePlan.totalPrice,
      };
      const res = await getRoomCancellationRulesApi(request);
      if (res && res.tncPolicy) {
        setTncPolicy(res?.tncPolicy);
        setShowTerms((prev) => !prev);
      } else {
        setAlert({
          variant: 'error',
          title: 'Terms and conditions',
          description: 'Failed to fetch terms and conditions',
        });
      }
      setIsLoading(false);
    }
  };
  const getCancellationText = () => {
    if (roomDetails.ratePlan.cancellationPolicy.freeCancellationAllowed) {
      return (
        <>
          <TiTick size={30} color="green" />
          <span style={{ color: 'green' }} className="font-weight-bold">
            Refundable
          </span>
        </>
      );
    } else {
      return (
        <>
          <ImCross color="red" />{' '}
          <span style={{ color: 'red' }} className="mx-2 font-weight-bold">
            Non-Refundable
          </span>
        </>
      );
    }
  };
  return (
    <Row className="spacing-16">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <Col
        className="room-options-section__room-card_image"
        lg={2}
        md={3}
        sm={12}
        xs={12}
      >
        {roomDetails.roomType?.thumbnail !== undefined &&
        roomDetails.roomType?.thumbnail !== '' ? (
          <div>
            <img
              src={
                roomDetails.roomType?.thumbnail
                  ? roomDetails.roomType.thumbnail
                  : thumbnail
              }
              alt={formattedMessage('room')}
            />
          </div>
        ) : (
          <div>
            <MdHotel size={110} />
          </div>
        )}
      </Col>
      <Col lg={10} md={9} sm={12} xs={12}>
        <Row className="spacing-0">
          <Col lg={8} md={8} sm={12} xs={12}>
            <div className="ms-3">
              <div>
                <span className="room-options-section__room-card_room-type">
                  {roomDetails.roomType?.roomTypeName}
                </span>
                <div className="fs-10">{roomDetails.roomType?.description}</div>
              </div>
              <div className="d-flex flex-wrap room-options-section__room-card_body">
                <div className="d-flex flex-column me-5">
                  <span>{roomDetails.ratePlan?.meals}</span>
                </div>
                <div className="d-flex flex-column">
                  <span>Highlights</span>
                  <span className="d-flex align-items-center">
                    {getCancellationText()}
                  </span>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={4} md={4} sm={12} xs={12}>
            <div className="d-flex justify-content-end">
              <div className="d-flex flex-column">
                <div className="pb-2">
                  <span className="room-options-section__room-card_actual-price">
                    {formatCurrency(roomDetails.nextratotalprice)}
                  </span>
                  <span className="room-options-section__room-card_nights">
                    {' '}
                    for {totalNights} Night(s)
                  </span>
                </div>
                <AppButton
                  variant="primary"
                  btnText={formattedMessage('book')}
                  onClick={() => onRoomChoose(roomDetails)}
                />
                <span className="room-options-section__room-card_discount pt-2">
                  <AppLink
                    linkText={formattedMessage('terms_conditions')}
                    onClick={() => handleTerms(roomDetails)}
                  />
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      {showTerms && tncPolicy && (
        <Col lg={12} md={12} sm={12} xs={12}>
          <TermsAndConditionsForHotelRoom tAndC={tncPolicy} />
        </Col>
      )}
    </Row>
  );
}

RoomCardUI.propTypes = {
  roomDetails: PropTypes.object.isRequired,
  thumbnail: PropTypes.string.isRequired,
  onRoomChoose: PropTypes.func.isRequired,
  currencyOption: PropTypes.any.isRequired,
  conversionRate: PropTypes.number.isRequired,
  searchRequest: PropTypes.any.isRequired,
  totalNights: PropTypes.number.isRequired,
};

function RoomOptions({
  roomOptions,
  thumbnail,
  onRoomChoose,
  currencyOption,
  conversionRate,
  searchRequest,
  totalNights,
}) {
  const intl = useIntl();
  const [roomsList, setRoomsList] = useState([]);
  const [mealOptions, setMealOptions] = useState([]);
  const [selectedMealType, setSelectedMealType] = useState({
    label: 'All',
    value: 'all',
  });
  const [selectedPanType, setSelectedPanType] = useState({
    label: 'All',
    value: 'all',
  });
  const selectedRefInfoRef = useRef({
    label: 'All',
    value: 'all',
  });
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  useEffect(() => {
    const meals = [];
    meals.push({
      label: 'All',
      value: 'all',
    });
    roomOptions.forEach((room) => {
      if (
        meals.findIndex(
          (x) =>
            x.value.toLowerCase().trim() ===
            room.ratePlan.meals.toLowerCase().trim(),
        ) === -1
      ) {
        meals.push({ label: room.ratePlan.meals, value: room.ratePlan.meals });
      }
    });
    setMealOptions(meals);
    setRoomsList(roomOptions);
  }, [roomOptions]);

  const handlePANDropdownChange = (event) => {
    const { value } = event;
    setSelectedPanType(event);
    let list = [...roomOptions];
    if (value !== 'all') {
      list = roomOptions.filter(
        (room) => room.roomType.ispan === value.toString(),
      );
    }
    if (selectedMealType.value !== 'all') {
      list = list.filter(
        (room) =>
          room.ratePlan.meals.toLowerCase().trim() ===
          selectedMealType.value.toLowerCase().trim(),
      );
    }
    setRoomsList(list);
  };

  const handleDropdownChange = (event) => {
    const { value } = event;
    setSelectedMealType(event);
    let list = [...roomOptions];
    if (value !== 'all') {
      list = roomOptions.filter(
        (room) =>
          room.ratePlan.meals.toLowerCase().trim() ===
          value.toLowerCase().trim(),
      );
    }
    if (selectedPanType.value !== 'all') {
      list = list.filter(
        (room) => room.roomType.ispan === selectedPanType.value.toString(),
      );
    }
    setRoomsList(list);
  };
  const handleFilterChange = (event, filterType) => {
    const { value } = event;
    if (filterType === 'pan') {
      setSelectedPanType(event);
    } else if (filterType === 'meal') {
      setSelectedMealType(event);
    } else if (filterType === 'ref-info') {
      selectedRefInfoRef.current = event;
    }

    const currentPanValue =
      filterType === 'pan' ? value : selectedPanType?.value;
    const currentMealValue =
      filterType === 'meal' ? value : selectedMealType?.value;
    const currentRefInfoValue =
      filterType === 'ref-info' ? value : selectedRefInfoRef.current?.value;

    let list = [...roomOptions];

    if (currentPanValue !== 'all') {
      list = list.filter(
        (room) => room.roomType.ispan === currentPanValue.toString(),
      );
    }

    if (currentMealValue !== 'all') {
      list = list.filter(
        (room) =>
          room.ratePlan.meals.toLowerCase().trim() ===
          currentMealValue.toLowerCase().trim(),
      );
    }
    if (currentRefInfoValue !== 'all') {
      list = list.filter(
        (room) =>
          room.ratePlan.cancellationPolicy.freeCancellationAllowed ===
          currentRefInfoValue,
      );
    }
    setRoomsList(list);
  };

  return (
    <section className="room-options-section">
      <div className="fs-16 fw-500 mb-2 d-flex justify-content-between">
        {formattedMessage('available_rooms')}
        <div className="d-flex flex-wrap gap-2">
          <div className="ms-2">
            <AppSelect
              selectWidth="250px"
              label={formattedMessage('Pan Filter')}
              placeholder=""
              className="app-select"
              name="title"
              options={[
                { label: 'All', value: 'all' },
                { label: 'PAN required', value: true },
                { label: 'PAN not required', value: false },
              ]}
              selectedValue={selectedPanType}
              onSelect={(value) => handleFilterChange(value, 'pan')}
              isClearable={false}
            />
          </div>
          <div className="ms-2">
            <AppSelect
              selectWidth="250px"
              label="Refundable Info"
              placeholder=""
              className="app-select"
              name="title"
              options={[
                { label: 'All', value: 'all' },
                { label: 'Free Cancellation', value: true },
                { label: 'Non-Refundable', value: false },
              ]}
              selectedValue={selectedRefInfoRef.current}
              onSelect={(value) => handleFilterChange(value, 'ref-info')}
              isClearable={false}
            />
          </div>
          <div className="ms-2">
            <AppSelect
              selectWidth="250px"
              label={formattedMessage('meal_filter')}
              placeholder=""
              className="app-select"
              name="title"
              options={mealOptions}
              selectedValue={selectedMealType}
              onSelect={(value, name) => handleDropdownChange(value)}
              isClearable={false}
            />
          </div>
        </div>
      </div>
      {roomsList.length > 0 && (
        <Row className="spacing-16 ">
          {roomsList.map((option, oIndex) => (
            <Col lg={12} md={12} sm={12} key={oIndex}>
              <Card className="room-options-section__room-card">
                <Card.Body>
                  {/* <Row className="spacing-16">
                      {option.rooms.map((room, rIndex) => (
                        <Col lg={12} md={12} sm={12} key={rIndex}> */}
                  <RoomCardUI
                    roomDetails={option}
                    thumbnail={thumbnail}
                    onRoomChoose={onRoomChoose}
                    currencyOption={currencyOption}
                    conversionRate={conversionRate}
                    searchRequest={searchRequest}
                    totalNights={totalNights}
                  />
                  {/* {option.rooms.length - 1 !== rIndex && (
                            <hr className="room-options-section__room-card_dashed-border" />
                          )}
                        </Col>
                      ))}
                    </Row> */}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
      {roomsList.length === 0 && (
        <Col lg={12} md={12} sm={12}>
          <div className="pt-3 text-center">
            <p className="red-color">
              No rooms found. Please change the filter criteria.
            </p>
          </div>
        </Col>
      )}
    </section>
  );
}

RoomOptions.defaultProps = {
  roomOptions: [],
  thumbnail: '',
};

RoomOptions.propTypes = {
  roomOptions: PropTypes.array,
  thumbnail: PropTypes.string,
  onRoomChoose: PropTypes.func.isRequired,
  currencyOption: PropTypes.any.isRequired,
  conversionRate: PropTypes.number.isRequired,
  searchRequest: PropTypes.any.isRequired,
  totalNights: PropTypes.number.isRequired,
};

export default RoomOptions;
